"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.buildSendQuery = void 0;
const viem_1 = require("viem");
const utils_1 = require("./axiom/utils");
const tools_1 = require("@axiom-crypto/core/packages/tools");
const buildSendQuery = async (input) => {
    const validate = input.options.validate ?? false;
    const query = input.axiom.query;
    if (input.options.refundee === undefined) {
        throw new Error("Refundee is required");
    }
    if (input.options.maxFeePerGas == undefined) {
        input.options.maxFeePerGas = await (0, utils_1.getMaxFeePerGas)(input.axiom);
    }
    const queryOptions = {
        maxFeePerGas: input.options.maxFeePerGas,
        callbackGasLimit: input.options.callbackGasLimit,
        overrideAxiomQueryFee: input.options.overrideAxiomQueryFee,
        dataQueryCalldataGasWarningThreshold: input.options.dataQueryCalldataGasWarningThreshold,
        refundee: input.options.refundee,
    };
    const qb = query.new(undefined, input.computeQuery, input.callback, queryOptions);
    if (input.dataQuery.length > 0) {
        qb.setBuiltDataQuery({
            subqueries: input.dataQuery,
            sourceChainId: input.axiom.config.chainId.toString(),
        }, true);
    }
    const { sourceChainId, queryHash, dataQueryHash, computeQuery, callback, feeData, userSalt, refundee, dataQuery, } = await qb.build(validate);
    const payment = await qb.calculateFee();
    const id = await qb.getQueryId(input.caller);
    const abi = input.axiom.getAxiomQueryAbi();
    const axiomQueryAddress = input.options.queryAddress ?? input.axiom.getAxiomQueryAddress();
    let sendQueryArgs;
    if (!input.options.ipfsClient) {
        sendQueryArgs = {
            address: axiomQueryAddress,
            abi: abi,
            functionName: "sendQuery",
            value: BigInt(payment),
            args: [
                sourceChainId,
                dataQueryHash,
                computeQuery,
                callback,
                feeData,
                userSalt,
                refundee,
                dataQuery,
            ],
            queryId: id,
            mock: input.axiom.config.mock,
        };
    }
    else {
        const encodedQuery = (0, tools_1.encodeFullQueryV2)(sourceChainId, refundee, {
            sourceChainId: input.axiom.config.chainId.toString(),
            subqueries: input.dataQuery,
        }, computeQuery, callback, feeData, userSalt, refundee);
        const pinRes = await input.options.ipfsClient.pin(encodedQuery);
        if (pinRes.status - 200 > 99) {
            throw new Error(`Failed to write data to IPFS. Status: ${pinRes.status}`);
        }
        const ipfsHash = pinRes.value;
        sendQueryArgs = {
            address: axiomQueryAddress,
            abi: abi,
            functionName: "sendQueryWithIpfsData",
            value: BigInt(payment),
            args: [
                queryHash,
                ipfsHash,
                callback,
                feeData,
                userSalt,
                refundee,
            ],
            queryId: id,
            mock: input.axiom.config.mock,
        };
    }
    const calldata = (0, viem_1.encodeFunctionData)(sendQueryArgs);
    return {
        ...sendQueryArgs,
        calldata,
    };
};
exports.buildSendQuery = buildSendQuery;
//# sourceMappingURL=sendQuery.js.map